import { render, staticRenderFns } from "./LibraryItemSearch.vue?vue&type=template&id=676cbe6c&scoped=true"
import script from "./LibraryItemSearch.vue?vue&type=script&lang=js"
export * from "./LibraryItemSearch.vue?vue&type=script&lang=js"
import style0 from "./LibraryItemSearch.vue?vue&type=style&index=0&id=676cbe6c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "676cbe6c",
  null
  
)

export default component.exports